<script lang="ts">
    import type {Employee} from "$lib/types/employee";
    import {page} from "$app/stores";
    import CardLayout from "$items/CardLayout.svelte";
    import {Button, Listgroup, Skeleton} from "flowbite-svelte";
    import {globalConfirm} from "$lib/stores/modal";

    let employee: Employee = $page.data.employee;

</script>

<div class="grid grid-cols-4 gap-3">
    <div class="space-y-3">
        <CardLayout title="User">
            <p>{employee.email}</p>
            <p class="pt-2">{employee.mobile}</p>
            <p class="pt-2"><strong>ID</strong> {employee.userId}</p>
        </CardLayout>
        <CardLayout title="Devices">
            {#if employee.connects?.length > 0}
                <Listgroup active items={employee.connects} let:item class="w-48" on:click={(ev) => {
                $globalConfirm.confirm(ev.detail.publicValue)
            }}>

                    {item.type}
                </Listgroup>
            {/if}
        </CardLayout>
    </div>
    <div class="col-span-2">
        <Skeleton size="md" class="my-8" />
    </div>
    <CardLayout title="Channel">
        <div class="flex flex-col gap-3">
            <Button>Whatsapp</Button>
            <Button>SMS</Button>
            <Button>Email</Button>
            <Button>App</Button>
        </div>
    </CardLayout>
</div>